import styled from 'styled-components';

export const List = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  padding: 0 20px;
`;

export const Item = styled.li`
  position: relative;
  padding: 5px 16px;
  font-size: 15px;
  color: var(--carbone50);

  a {
    font-size: 15px;
    color: var(--carbone50);
    text-decoration: none;
    transition: var(--transition);

    &.is_active {
      color: var(--carbone100);
      font-weight: 600;
    }
  }

  &:not(:last-child):after {
    content: '';
    width: 1px;
    height: 20px;
    background: var(--aluminium75);
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;
